import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
// Importing Lucide icons for the AR environment section
import { Table, Globe } from 'lucide-react';
import addToCart from '../../../services/bffService';
// Removed unused video-react and other imports for a cleaner file

function AugRealityComponent() {
    const [showLoading, setShowLoading] = useState(false);
  
  const addProductToCart = (id) => {
    setShowLoading(true);
    addToCart(id);
  }

  const arProductId = "69193ae1b7b0f000105d226e";
  // const productInfo = {
  //   "description": "AR App Access",
  //   "productId": "69193ae1b7b0f000105d226e",
  //   "price" : "12.99",
  //   "currency" : "USD",
  // }
  
  // No need for UnitCard or YouTube specific functions in the final component

  return (
    <div width="100%">
      
      {/* Top Header Section */}
      {/* <div className="product-container">
        <Container>
          <Row className="py-4 align-items-center">
            <Col xs={12} md={8} lg={7}>
              <h1 className="catalogueHeader mb-3">View the Biology In The Real World</h1>
              <div className="d-flex align-items-center">
                <h4 className="text-white opacity-75 me-3 mb-0">
                  Starting at $12.99
                </h4>
                <a href="/trial">
                  <button className="trial-button">Purchase Today</button>
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </div> */}


      {/* Main AR Feature Section: Text, Price Banner, and Fanned Images */}
      <Container className="my-5">
        <Row className="align-items-center justify-content-center">
          
          {/* Column for Text and Price Banner */}
          <Col md={6} className="text-center">
            
            {/* Enhanced Copy */}
            <h1 className="closer-headline mb-4" style={{ textAlign: "center", fontSize: "3rem" }}>
                Biology Unleashed: <br/>Experience AR in Your World
            </h1>
            <p style={{ fontSize: "19px", textAlign: "justify", maxWidth: "500px", margin: "0 auto 20px auto" }}>
              Discover the living world like never before with our new Augmented Reality (AR) feature. Interact with stunning 3D models, dynamic animations, and immersive experiences that bring complex biological concepts to life, right in your own environment.
            </p>
            
            {/* Price Banner */}
            <div className="price-banner-container">
                <p className="price-banner-text mb-0" style={{fontSize: "14px",}}>
                    Only $12.99
                </p>
            </div>
            {/* Price Banner */}
            {/* <div className="price-banner-container">
                <p className="price-banner-text mb-0" style={{fontSize: "14px", display: "flex", alignItems: "center", flexWrap: "wrap", justifyContent: "center"}}>
                  
                    <span className="original-price me-2">
                        $12.99
                    </span>
                    {/* The new discounted message */}
                    {/* <span className="discount-message">
                        Only <strong>$6.49</strong> for Black Friday / Cyber Monday!
                    </span>
                </p>
            </div> */} 
            
            {/* Purchase Button */}
            
                <button onClick={() => addProductToCart(arProductId)} className="purchase-button" style={{ width: '40%' }}>Purchase Now</button>
          
            
          </Col>

          {/* Column for Fanned Images */}
          <Col md={6} className="d-flex justify-content-center align-items-center" style={{ minHeight: '600px', position: 'relative' }}>
            <div className="fanned-iphones-wrapper">
              
              {/* iPhone 1 (back-left) */}
              <div className="iphone-frame-container iphone-fan-1">
                <img
                  src="https://storage.googleapis.com/sb-general/Simulator%20Screenshot%20-%20iPhone%2016%20-%202025-07-08%20at%2022.58.46.png"
                  alt="AR Feature Screenshot 1"
                  className="iphone-content-image"
                />
              </div>

              {/* iPhone 2 (center-front) */}
              <div className="iphone-frame-container iphone-fan-2">
                <img
                  src="https://storage.googleapis.com/sb-general/Simulator%20Screenshot%20-%20iPhone%2016%20-%202025-07-08%20at%2022.58.46.png"
                  alt="AR Feature Screenshot 2"
                  className="iphone-content-image"
                />
              </div>

              {/* iPhone 3 (back-right) */}
              <div className="iphone-frame-container iphone-fan-3">
                <img
                  src="https://storage.googleapis.com/sb-general/Simulator%20Screenshot%20-%20iPhone%2016%20-%202025-07-08%20at%2022.58.46.png"
                  alt="AR Feature Screenshot 3"
                  className="iphone-content-image"
                />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      
      <hr className="section-divider" />
      
      {/* AR Environment Section */}
      <Container className="my-5 py-5">
        <Row className="justify-content-center mb-5">
          <Col xs={12} className="text-center">
            <h2 className="ar-env-headline">Experience AR Anywhere: Your World, Your Lab.</h2>
            <p className="lead text-muted">
              From the intricate details of a cell to the vastness of an ecosystem, AR brings biology to life in any environment.
            </p>
          </Col>
        </Row>

        <Row className="justify-content-center align-items-stretch g-4">
          
          {/* "View on Your Table" Column */}
          <Col md={6} lg={5} className="d-flex">
            <div className="ar-env-card">
              <div className="ar-env-icon-wrapper">
                <Table size={48} color="#4CAF50" />
              </div>
              <h3 className="ar-env-card-title">On Your Tabletop</h3>
              <p className="ar-env-card-text">
                Bring microscopic worlds to your desk. Explore detailed 3D anatomical structures, cellular processes, and molecular interactions right in front of you, perfect for focused study and hands-on understanding.
              </p>
              <img
                src="https://storage.googleapis.com/sb-general/ARImages/table_screenshot.png"
                alt="AR experience on a table"
                className="img-fluid rounded-lg mt-3"
                style={{width: "50%", margin: "auto"}}
              />
            </div>
          </Col>

          {/* "View Outside" Column */}
          <Col md={6} lg={5} className="d-flex">
            <div className="ar-env-card">
              <div className="ar-env-icon-wrapper">
                <Globe size={48} color="#2196F3" />
              </div>
              <h3 className="ar-env-card-title">In the Great Outdoors</h3>
              <p className="ar-env-card-text">
                Step into virtual ecosystems. Visualize large-scale biological phenomena, analyze environmental impacts, or observe animal behaviors in their natural habitats, all overlaid onto your real-world surroundings.
              </p>
              <img
                src="https://storage.googleapis.com/sb-general/ARImages/floor_screenshot.png"
                alt="AR experience outdoors"
                className="img-fluid rounded-lg mt-3"
                style={{width: "50%", margin: "auto"}}
              />
            </div>
          </Col>
        </Row>
      </Container>

      <hr className="section-divider" />
      
      {/* Closing Call-to-Action Section */}
      <Container className="my-5 py-5 text-center">
        <Row className="justify-content-center">
          <Col xs={12} md={8} lg={6}>
            <h2 className="closer-headline mb-4">Ready to Explore Biology in a New Dimension?</h2>
            <p className="lead text-muted mb-4">
              Unlock a deeper understanding of life sciences with interactive AR experiences. Start your journey today!
            </p>
            
              <button onClick={() => addProductToCart(arProductId)} className="purchase-button">Purchase Today</button>

          </Col>
        </Row>
      </Container>
      
    </div>
  );
}

export default AugRealityComponent;